/* eslint-disable max-len */

export const getWarningMessageForEarlierEndDate = (initialTermPassed?: boolean | null) => {
  return (
    <>
      The End date you are about to save is earlier than current date. <br />
      If the renewable term of the contract is more than 0, the Contract will roll over as a
      result of nightly updates. <br />
      {initialTermPassed && <>The contract's initial term has already passed, contract lines won't be affected.</>}
      Do you want to proceed?
    </>
  );
};

export const getWarningMessageForSucessfulSOSent = (initialTermPassed?: boolean | null) => {
  return (
    <>
      The contract has been billed in the period between the current date
      and the end date <br /> you have just provided. 
      {initialTermPassed && <>The contract's initial term has already passed, contract lines won't be affected.</>}
      Do you want to save the new Contract End Date anyway?
    </>
  );
};